import { BaseModel } from '~/models/baseModel';

export class FaqItemModel extends BaseModel {
    public question:string;
    public answer:string;
}
